// extracted by mini-css-extract-plugin
export default {"link":"Footer_link__-iPvI"};